module.exports = __webpack_public_path__ + "img/counter-icon-2.b7e76514.svg";